import { Link, styled } from '@mui/material'

export const LinkContent = styled(Link)`
  text-decoration: none;
  &:focus {
    outline: none;
    padding: 0;
  }
  width: 100%;
`
